import links from "../../utils/links";
import imageScheme from '../../images/schemes/Scheme-Payouts-EN.svg';
import iconDelivery from "../../images/icons/styled/first/Delivery.svg";
import iconTraining from "../../images/icons/styled/first/Training.svg";
import iconUserCheck from "../../images/icons/styled/first/UserCheck.svg";
import iconLightning from "../../images/icons/styled/first/Lightning.svg";
import iconCheck from "../../images/icons/styled/first/CheckInCircle.svg";
import iconShield from "../../images/icons/styled/first/Shield.svg";
import iconAPI from "../../images/icons/styled/first/API.svg";
import iconFlag from "../../images/icons/styled/first/Flag.svg";


export default {
    "seo": {
        "title": "Service for mass payouts to individuals in Russia | Bank 131",
        "description": "Mass payouts to Russian freelancers: developers, designers, copywriters, tutors, interpreters, etc. Compliance with Russian tax rules."
    },
    "pageHeaderBlock": {
        "title": "Send payouts to freelancers and self-employed people",
        "text": "Send money to freelancers’ and outsourcers’ bank cards, bank accounts and e-wallets. Fast and convenient, with or without API integration."
    },
    "infoCardsBlock": {
        "listTitle": "For IT businesses",
        "list": [
            'A solution designed for Russian and international companies, fintech and payment providers who work with freelancers, remote workers or distributed teams.',
            'Handy for people who work or plan to work with self-employed Russians:'
        ],
        "cards": [
            {
                "title": 'E-commerce or online services',
                "text": 'to pay marketing affiliates',
                "icon": iconDelivery,
                "description": '',
                "theme": 'cardFirst'
            },
            {
                "title": 'Online education platforms',
                "text": 'to pay tutors and teachers',
                "icon": iconTraining,
                "description": '',
                "theme": 'cardFirst'
            },
            {
                "title": 'Freelancing platforms',
                "text": 'to pay designers, copywriters, photographers, web developers, interpreters',
                "icon": iconUserCheck,
                "description": '',
                "theme": 'cardFirst'
            }
        ]
    },
    "stepsBlock": {
        "title": "How to pay out to the self-employed",
        "list": [
            {
                "title": 'Verification',
                "text": 'We verify the recipient’s tax status through direct integration with the local Federal Tax Agency (currently in Russia only).'
            },
            {
                "title": 'Registration',
                "text": 'If necessary, we register the recipient as self-employed, with their consent'
            },
            {
                "title": 'Payout',
                "text": 'Bank 131 sends the payout to the self-employed individual’s bank card, Russian bank account or e-wallet. The tax they owe is accrued and paid on their behalf.'
            },
            {
                "title": 'Confirmation',
                "text": 'We send you the fiscal receipt (the document your company accounting team need in order to prove tax has been paid).',
                "image": imageScheme,
                "imageLabel": 'View diagram'
            }
        ]
    },
    "infoCardsBlockSecond": {
        "cardsTitle": "You’ll like it",
        "cards": [
            {
                "title": 'Process made easy with instant payouts',
                "text": 'You can pass us your data on amounts due to recipients via an API.  The payout is made instantly, so the recipient gets it within a few minutes. \n' +
                    'All the payouts are compiled in a daily report and sent to your e-mail.\n',
                "icon": iconLightning,
                "description": '',
                "theme": 'withoutBackground'
            },
            {
                "title": 'Compliance ',
                "text": 'We verify and validate the legal basis for payouts. All payouts are made in strict accordance with local tax and AML/CFT rules. ',
                "icon": iconCheck,
                "description": '',
                "theme": 'withoutBackground'
            },
            {
                "title": 'Data protection and security',
                "text": 'Recipients’ personal and payment data is processed in line with all the relevant requirements. \n' +
                    'All requests sent to the API are reliably encrypted.\n',
                "icon": iconShield,
                "description": '',
                "theme": 'withoutBackground'
            },
            {
                "title": 'API integration',
                "text": 'We focus on automation, and on offering a service that makes any manual work on your part unnecessary.' +
                    ' We’ve made our API integration transparent by giving you the chance to test-drive the API before you launch it for real.',
                "icon": iconAPI,
                "description": '',
                "theme": 'withoutBackground'
            },
            {
                "title": 'Direct integration with the Federal Tax Agency',
                "text": 'Bank 131 is accredited by Russia’s Federal Tax Agency. We check recipients’ tax status, register them ' +
                    'as self-employed, issue fiscal receipts and pay tax on their behalf.',
                "icon": iconFlag,
                "description": '',
                "theme": 'withoutBackground'
            }
        ]
    },
    "infoCardsBlockThird": {
        "listTitle": "Getting started",
        "list": [
            'Send a request, sharing your requirements and goals',
            'We’ll find you a suitable solution',
            'We’ll also need to check your documents',
            'Next, you sign a contract',
            `And you’re all set to start <a href="${links.en.api}" target="_blank" rel="noreferrer">API integration</a>`
        ],
        "listGoTo": {
            "text": 'Pricing',
            "to": '/en/pricing'
        }
    },
    "submitApplicationBlock": {
        "title": "How to connect payments",
        "textSubmit": "Sign up",
        "textSubmitBottom": "Get in touch",
    }
}